import { FC, PropsWithChildren } from 'react';
import { Box } from '@mui/material';


export const MainLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box width="100%">
      <Box
        sx={{
          backgroundImage: 'linear-gradient(rgb(246, 248, 249), rgb(0, 75, 102))',
          overflowY: 'auto',
        }}
        height="calc(100dvh - 64px)"
        my={{ xs: -1, sm: -4 }}
        mx={{ xs: -2, sm: -5 }}
      >
        {children}
      </Box>
    </Box>
  );
};
